<template>
  <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog')" @keydown.esc="$emit('updateDialog')" width="750">
    <v-card>
      <v-card-title class="title-modal">
        <span class="headline">{{ modal_title }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-text-field v-if="item.assigned_location_id > 0" v-model="item.almacen_name" density="comfortable" name="almacen_name" label="Almacén" :disabled="true"></v-text-field>

          <v-combobox
            v-model="item.product"
            name="product"
            item-title="label"
            item-value="id"
            :items="products"
            label="Producto*"
            autocomplete="off"
            :rules="[rules.requiredComboBox]"
            @update:modelValue="onProductChange"
            clearable
            :disabled="item.assigned_location_id > 0"
          ></v-combobox>

          <v-combobox
            v-if="item.product != null && item.product.tiene_control_de_calidad"
            v-model="item.quality"
            name="quality"
            item-title="name"
            item-value="id"
            :items="qualities"
            label="Calidad*"
            autocomplete="off"
            :rules="[rules.requiredComboBox]"
            clearable
            :disabled="item.assigned_location_id > 0"
          ></v-combobox>

          <v-text-field
            v-if="item.product && item.product.tiene_control_por_lotes"
            autocomplete="off"
            name="lote"
            label="Lote"
            type="text"
            v-model="item.lote"
            :rules="[rules.required]"
            :disabled="item.assigned_location_id > 0"
          />

          <v-text-field
            v-if="item.product && item.product.tiene_control_por_serie"
            autocomplete="off"
            name="serie"
            label="Nº Serie"
            type="text"
            v-model="item.serie"
            :rules="[rules.required]"
            :disabled="item.assigned_location_id > 0"
          />

          <v-text-field
            v-if="item.product && item.product.storage_unit && item.product.storage_unit.id != productoService.STORAGE_UNITS_ID"
            autocomplete="off"
            name="storage_units_amount"
            label="Valor de almacenamiento"
            type="number"
            v-model="item.storage_units_amount"
          />

          <v-text-field
            v-if="item.product && item.product.tiene_control_por_descriptivo_1"
            autocomplete="off"
            name="descriptivo_1"
            :label="getAliasName('descriptivo_1')"
            type="text"
            v-model="item.descriptivo_1"
            :disabled="item.assigned_location_id > 0"
          />

          <v-text-field
            v-if="item.product && item.product.tiene_control_por_descriptivo_2"
            autocomplete="off"
            name="descriptivo_2"
            :label="getAliasName('descriptivo_2')"
            type="text"
            v-model="item.descriptivo_2"
            :disabled="item.assigned_location_id > 0"
          />

          <v-text-field
            v-if="item.product && item.product.tiene_control_por_descriptivo_3"
            autocomplete="off"
            name="descriptivo_3"
            :label="getAliasName('descriptivo_3')"
            type="text"
            v-model="item.descriptivo_3"
            :disabled="item.assigned_location_id > 0"
          />

          <v-text-field
            v-if="item.product && item.product.requiere_fecha_expiracion"
            v-model="item.expiration_date"
            name="expiration_date"
            label="Fecha de Expiración"
            scrollable
            type="date"
            :rules="[rules.required]"
          ></v-text-field>

          <v-text-field v-model="item.entry_date" name="entry_date" label="Fecha de Ingreso" scrollable type="date" :rules="[rules.required]" :disabled="item.assigned_location_id > 0"></v-text-field>

          <v-combobox
            v-model="item.product_status"
            name="estado"
            item-title="name"
            item-value="id"
            :items="states"
            label="Estado"
            autocomplete="off"
            :disabled="item.assigned_location_id > 0"
            :rules="[rules.requiredComboBox]"
            clearable
          ></v-combobox>

          <v-text-field
            v-model="item.lpn_code"
            density="comfortable"
            name="lpn_code"
            label="LPN"
            :rules="[rules.required, validateLPN]"
            @update:modelValue="validateStatesLPN"
            :loading="loading_validate_lpn"
            :disabled="item.assigned_location_id > 0"
          ></v-text-field>

          <v-text-field v-model="item.ubicacion_code" density="comfortable" name="ubicacion_code" label="Ubicacion" :rules="[rules.required]" :disabled="item.assigned_location_id > 0"></v-text-field>

          <div v-if="item.assigned_location_id > 0" class="mb-4">
            <v-alert type="info" variant="tonal" class="mb-3">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="text-subtitle-2 font-weight-bold">Stock Actual</div>
                  <div class="text-h5 mt-1">{{ item.available_stock || 0 }}</div>
                </div>
              </div>
            </v-alert>
          </div>

          <p class="fs-16 font-weight-bold mb-2" v-if="item.assigned_location_id > 0">Tipo de ajuste</p>
          <v-radio-group v-model="item.ajuste_type" v-if="item.assigned_location_id > 0" class="mt-0">
            <v-radio label="Positivo (Aumentar stock)" value="P"></v-radio>
            <v-radio label="Negativo (Disminuir stock)" value="N"></v-radio>
          </v-radio-group>

          <v-text-field
            name="base_amount"
            :label="item.assigned_location_id > 0 ? 'Cantidad a ajustar' : 'Cantidad'"
            type="number"
            v-model="item.base_amount"
            :rules="[rules.required, validateBaseAmount]"
            min="0"
            step="1"
          />

          <v-alert v-if="item.assigned_location_id > 0 && item.base_amount && parseFloat(item.base_amount) > 0" :type="stockResultType" variant="tonal" class="mb-3">
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="text-subtitle-2 font-weight-bold">Stock Resultante</div>
                <div class="text-h5 mt-1 d-flex align-center">
                  <span>{{ stockResultado }}</span>
                  <v-icon class="ml-2" :color="stockResultType">
                    {{ item.ajuste_type === "P" ? "mdi-arrow-up-bold" : "mdi-arrow-down-bold" }}
                  </v-icon>
                </div>
              </div>
              <div class="text-caption">{{ item.available_stock || 0 }} {{ item.ajuste_type === "P" ? "+" : "-" }} {{ item.base_amount }} = {{ stockResultado }}</div>
            </div>
          </v-alert>

          <v-textarea v-model="item.observation" name="observation" label="Observación" scrollable :rules="[rules.required]"></v-textarea>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="$emit('updateDialog')"> Cancelar </v-btn>
        <v-btn color="green" text @click="createItem()" :loading="loading_ajuste"> {{ itemEdit != null ? "Editar" : "Agregar" }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { lpnService } from "@/libs/ws/lpnService";
import { productoService } from "@/libs/ws/productoService";
import { productQualityService } from "@/libs/ws/productQualityService";
import ValidMixin from "@/mixins/ValidMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";

export default {
  created() {},
  mixins: [ValidMixin, AliasMixin],
  components: {},
  props: {
    dialog: Boolean,
    updateDialog: Function,
    itemEdit: Object,
    service: Object,
    loadAssignedLocations: Array,
  },
  data: () => ({
    productoService: productoService,
    item: {
      assigned_location_id: 0,
      product: null,
      amount: null,
      manufacture_date: null,
      expiration_date: null,
      entry_date: new Date(
        new Date().toLocaleDateString("en-US", {
          timeZone: "America/Buenos_Aires",
        })
      )
        .toISOString()
        .slice(0, 10),
      lote: null,
      serie: null,
      descriptivo_1: null,
      descriptivo_2: null,
      descriptivo_3: null,
      storage_units_amount: null,
      quality: null,
      base_amount: null,
      ajuste_type: "P",
      lpn_code: null,
      ubicacion_code: null,
      almacen_name: null,
      observation: "",
      product_status: null,
    },
    defaultItem: null,
    presentation_products: [],
    loading_product: false,
    loading_validate_lpn: false,
    loading_ajuste: false,
    products: [],
    qualities: [],
    states: [],
    modal_title: "Ajuste",
  }),
  computed: {
    stockResultado() {
      if (!this.item.base_amount || !this.item.available_stock) return 0;
      const stockActual = parseFloat(this.item.available_stock) || 0;
      const cantidad = parseFloat(this.item.base_amount) || 0;
      if (this.item.ajuste_type === "P") {
        return stockActual + cantidad;
      } else {
        return Math.max(0, stockActual - cantidad);
      }
    },
    stockResultType() {
      return this.item.ajuste_type === "P" ? "success" : "warning";
    },
  },
  watch: {
    dialog() {
      if (this.itemEdit == null) {
        this.item = JSON.parse(JSON.stringify(this.defaultItem));
      } else {
        this.item = JSON.parse(JSON.stringify(this.itemEdit));
        this.item.lpn_code = this.itemEdit.lpn.code;
        this.item.ubicacion_code = this.itemEdit.ubicacion.code;
        this.item.almacen_name = this.itemEdit.ubicacion.zona.almacen ? this.itemEdit.ubicacion.zona.almacen.name : "";
        this.item.product = this.itemEdit.presentation_atributes.product_presentation.product;
        this.item.serie = this.itemEdit.presentation_atributes.serie;
        this.item.lote = this.itemEdit.presentation_atributes.lote;
        this.item.descriptivo_1 = this.itemEdit.presentation_atributes.descriptivo_1;
        this.item.descriptivo_2 = this.itemEdit.presentation_atributes.descriptivo_2;
        this.item.descriptivo_3 = this.itemEdit.presentation_atributes.descriptivo_3;
        this.item.storage_units_amount = this.itemEdit.presentation_atributes.storage_units_amount;
        this.item.quality = this.itemEdit.presentation_atributes.quality;
        this.item.expiration_date = this.itemEdit.presentation_atributes.expiration_date;
        this.item.product_status = this.itemEdit.presentation_atributes.product_status;
        this.item.entry_date = this.itemEdit.presentation_atributes.entry_date;
        this.item.current_amount = this.itemEdit.location_stock;
        this.item.assigned_location_id = this.itemEdit.id;
        this.item.ajuste_type = "P";
      }
    },
  },
  mounted() {
    this.loadProducts();
    this.loadStatesProducts();
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    validateStatesLPN(value) {
      if (!value) return;

      this.loading_validate_lpn = true;
      const params = {
        lpn_code: value,
        task_type: null,
      };

      lpnService
        .scan(params)
        .then((response) => {
          if (response.status) {
            const state_id = response.result.lpn.state.id;
            if (![lpnService.STATE_NO_USED, lpnService.STATE_LOCATED, lpnService.STATE_RECEIVED].includes(state_id)) {
              this.lpnError = "El estado del LPN no es válido.";
              this.item.ubicacion_code = null;
            } else {
              this.lpnError = "";
              this.item.ubicacion_code = response.result.ubicacion != null ? response.result.ubicacion.code : null;
            }
          }
        })
        .catch(() => {
          this.lpnError = "Error validando el LPN.";
        })
        .finally(() => {
          this.loading_validate_lpn = false;
        });
    },
    validateLPN() {
      return this.lpnError || true;
    },
    validateBaseAmount(value) {
      if (!value || parseFloat(value) <= 0) {
        return "La cantidad debe ser mayor a 0";
      }

      // Validar que al disminuir no se exceda el stock disponible
      if (this.item.assigned_location_id > 0 && this.item.ajuste_type == "N") {
        const stockActual = parseFloat(this.item.available_stock) || 0;
        const cantidadAjustar = parseFloat(value) || 0;

        if (cantidadAjustar > stockActual) {
          return `No puedes disminuir más de ${stockActual}. Stock actual: ${stockActual}`;
        }
      }

      if (this.item.product && this.item.product.tiene_control_por_serie && parseFloat(value) > 1) {
        return "La cantidad no puede ser mayor 1.";
      }

      return true;
    },
    async createItem() {
      if (this.loading_ajuste) return;
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.loading_ajuste = true;

        const isEdit = this.item.id > 0;
        const data = {
          ajuste_type: { id: this.item.ajuste_type },
          base_amount: this.item.base_amount,
          observation: this.item.observation,
          ...(isEdit
            ? { assigned_location_id: this.item.assigned_location_id }
            : {
                product: { id: this.item.product.id },
                ubicacion_code: this.item.ubicacion_code,
                lpn_code: this.item.lpn_code,
                lote: this.item.lote,
                serie: this.item.serie,
                descriptivo_1: this.item.descriptivo_1,
                descriptivo_2: this.item.descriptivo_2,
                descriptivo_3: this.item.descriptivo_3,
                storage_units_amount: this.item.storage_units_amount,
                manufacture_date: this.item.manufacture_date,
                expiration_date: this.item.expiration_date,
                entry_date: this.item.entry_date,
                quality: this.item.quality,
                product_status: { id: this.item.product_status.id },
              }),
        };

        if (isEdit) {
          this.service
            .performe_ajuste(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("El " + this.modal_title + " se modifico correctamente.");
                this.$emit("updateDialog");
                this.$emit("loadAssignedLocations");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((response) => {
              this.toast.error(response.msg);
            })
            .finally(() => {
              this.loading_ajuste = false;
            });
        } else {
          this.service
            .performe_ajuste(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("El " + this.modal_title + " se creo correctamente");
                this.$emit("updateDialog");
                this.$emit("loadAssignedLocations");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((e) => {
              this.toast.error(e);
            })
            .finally(() => {
              this.loading_ajuste = false;
            });
        }
      }
    },
    loadStatesProducts() {
      productoService.getStates().then((response) => {
        this.states = response.result.list;
      });
    },
    onProductChange() {
      this.loadProductData();
      this.loadQualities();
    },
    loadProductData() {
      if (this.item.product != null) {
        this.item.lote = this.item.product.tiene_control_por_lotes ? this.item.product.lote || "" : null;
        this.item.serie = this.item.product.tiene_control_por_serie ? this.item.product.serie || "" : null;
        this.item.descriptivo_1 = this.item.product.tiene_control_por_descriptivo_1 ? this.item.product.descriptivo_1 || "" : null;
        this.item.descriptivo_2 = this.item.product.tiene_control_por_descriptivo_2 ? this.item.product.descriptivo_2 || "" : null;
        this.item.descriptivo_3 = this.item.product.tiene_control_por_descriptivo_3 ? this.item.product.descriptivo_3 || "" : null;
        this.item.storage_units_amount = this.item.product.storage_unit && this.item.product.storage_unit.id != productoService.STORAGE_UNITS_ID ? this.item.product.storage_units_amount || "" : null;
        this.item.expiration_date = this.item.product.requiere_fecha_expiracion ? this.item.product.expiration_date || "" : null;
        this.item.entry_date = this.item.product.entry_date;
        this.item.quality = this.item.product.tiene_control_de_calidad ? this.item.product.quality || "" : null;
      } else {
        this.item.lote = null;
        this.item.serie = null;
        this.item.descriptivo_1 = null;
        this.item.descriptivo_2 = null;
        this.item.descriptivo_3 = null;
        this.item.storage_units_amount = null;
        this.item.expiration_date = null;
        this.item.entry_date = null;
        this.item.quality = null;
      }
    },
    loadProducts() {
      // let client = this.shipment_order.client != null ? this.shipment_order.client.id : null;

      this.loading_product = true;
      productoService
        .filter({})
        .then((response) => {
          this.products = response.result.list;
        })
        .finally(() => {
          this.loading_product = false;
        });
    },
    loadQualities() {
      if (this.item.product != null) {
        productQualityService.filter({ product: this.item.product.id }).then((response) => {
          this.qualities = response.result.list;
        });
      }
    },
  },
};
</script>
